import React, { Component } from 'react';
import { Field } from 'formik';
import { Form, Button, Grid } from 'semantic-ui-react';
import { Element } from 'react-scroll';
import { withLocalize } from 'react-localize-redux';
import styled from 'styled-components';
import { debounce } from 'lodash';
import moment from 'moment';
import { HHInput, HHSlug, HHLocationSelect, HHSingleSelect, HHDatePicker } from './fields';
import HHSingleSelectLightBtn from './fields/hhSingleSelectLightBtn';
// eslint-disable-next-line import/no-named-as-default
import { getTimeZoneOptions } from '../common/datetime';
import CreateEventQuitModal from '../events/components/createEventQuitModal';

const styles = {
  descItemColumn: { width: '33.3%' }
};

class EventFormBasicInfo extends Component {
  saveAndContinue = e => {
    e.preventDefault();
    this.props.nextStep(1);
  };

  render() {
    const {
      translate, isEditing, values, getLocationOptions, activeLanguage
    } = this.props;

    return (
      <div className='create-event-container'>
        {!isEditing && (
          <CreateEventQuitModal />
        )}
        <div className='ui two column grid'>
          {!isEditing && (
            <div className='column main' >
              <CreateEventDescBg>
                <CreateEventDescContainer>
                  <DescTitle>{translate('createEvent.hackhubEvent')}</DescTitle>
                  <DescSubTitle>{translate('createEvent.subTitle')}</DescSubTitle>
                  <DescItemList>
                    <Grid>
                      <Grid.Row textAlign='center'>
                        <Grid.Column style={styles.descItemColumn}>
                          <DescItem>
                            <DescItemIcon url='/img/event/icons/createEvent/ticket.png' />
                            <DescItemText>{translate('eventInfo.ticket')}</DescItemText>
                          </DescItem>
                        </Grid.Column>
                        <Grid.Column style={styles.descItemColumn}>
                          <DescItem>
                            <DescItemIcon url='/img/event/icons/createEvent/team.png' />
                            <DescItemText>{translate('eventInfo.smartTeam')}</DescItemText>
                          </DescItem>
                        </Grid.Column>
                        <Grid.Column style={styles.descItemColumn}>
                          <DescItem>
                            <DescItemIcon url='/img/event/icons/createEvent/screen.png' />
                            <DescItemText>{translate('eventInfo.screening')}</DescItemText>
                          </DescItem>
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row textAlign='center'>
                        <Grid.Column style={styles.descItemColumn}>
                          <DescItem>
                            <DescItemIcon url='/img/event/icons/createEvent/submission.png' />
                            <DescItemText>{translate('eventInfo.onlineSubmission')}</DescItemText>
                          </DescItem>
                        </Grid.Column>
                        <Grid.Column style={styles.descItemColumn}>
                          <DescItem>
                            <DescItemIcon url='/img/event/icons/createEvent/announcement.png' />
                            <DescItemText>{translate('eventInfo.announcement')}</DescItemText>
                          </DescItem>
                        </Grid.Column>
                        <Grid.Column style={styles.descItemColumn}>
                          <DescItem>
                            <DescItemIcon url='/img/event/icons/createEvent/judging.png' />
                            <DescItemText>{translate('eventInfo.mobileJuding')}</DescItemText>
                          </DescItem>
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row textAlign='center'>
                        <Grid.Column style={styles.descItemColumn}>
                          <DescItem>
                            <DescItemIcon url='/img/event/icons/createEvent/tech-support.png' />
                            <DescItemText>{translate('eventInfo.support')}</DescItemText>
                          </DescItem>
                        </Grid.Column>
                        <Grid.Column style={styles.descItemColumn}>
                          <DescItem>
                            <DescItemIcon url='/img/event/icons/createEvent/multi-round.png' />
                            <DescItemText>{translate('eventInfo.multiRound')}</DescItemText>
                          </DescItem>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </DescItemList>
                </CreateEventDescContainer>
              </CreateEventDescBg>
            </div>
          )}
          <div className='column main'>
            <Form className='cms-create-event-form'>
              <FormHeader>
                {translate('createEvent.form.header.basic')}
              </FormHeader>
              <FormSubHeader>
                {translate('createEvent.form.subHeader.nameNLocation')}
              </FormSubHeader>
              <section className='section'>
                <Form.Field name='position-name'>
                  <Element>
                    <FieldsHeader>
                      <FieldsOrderNumber>1</FieldsOrderNumber>
                      <FieldsHeaderText>{translate('event.name')}</FieldsHeaderText>
                    </FieldsHeader>
                    <FieldsContent>
                      <Field
                        name='name'
                        component={HHInput}
                        onChange={this.props.handleChange}
                        otherProps={{
                          type: 'text',
                          id: 'form-eventName',
                          className: 'ui input form-basicInfo',
                          maxLength: 64,
                          placeholder: translate('your event name')
                        }}
                      />
                    </FieldsContent>
                  </Element>
                </Form.Field>
              </section>
              <section className='section'>
                <Form.Field name='position-slug'>
                  <Element>
                    <FieldsHeader>
                      <FieldsOrderNumber>2</FieldsOrderNumber>
                      <FieldsHeaderText>{translate('customUrl')}</FieldsHeaderText>
                    </FieldsHeader>
                    <FieldsContent>
                      <Field
                        name='slug'
                        component={HHSlug}
                        onChange={this.props.handleChange}
                        otherProps={{
                          type: 'text',
                          id: 'form-slug',
                          className: 'ui input form-basicInfo',
                          maxLength: 64,
                          placeholder: translate('yourEventSlug')
                        }}
                      />
                      <FieldsHelpText>{translate('customUrlInstruction')}</FieldsHelpText>
                    </FieldsContent>
                  </Element>
                </Form.Field>
              </section>
              <section className='section'>
                <Form.Field>
                  <FieldsHeader>
                    <FieldsOrderNumber>3</FieldsOrderNumber>
                    <FieldsHeaderText>{translate('eventOnlineInPerson')}</FieldsHeaderText>
                  </FieldsHeader>
                  <FieldsContent>
                    <Field name='isOnline' component={HHSingleSelectLightBtn} />
                  </FieldsContent>
                </Form.Field>
              </section>
              {values.isOnline === 'offline' || values.isOnline === 'hybrid' ? (
                <section className='section location cms-create-event-form'>
                  <Form.Field>
                    <FieldsHeader>
                      <FieldsOrderNumber>3.1</FieldsOrderNumber>
                      <FieldsHeaderText>{translate('eventWhere')}</FieldsHeaderText>
                    </FieldsHeader>
                    <FieldsContent>
                      <Field
                        name='location'
                        component={HHLocationSelect}
                        otherProps={{
                          async: true,
                          loadOptions: debounce(getLocationOptions, 1000),
                          placeholder: translate('eventLocationPlaceholder'),
                          filterOptions: options => options
                        }}
                      />
                    </FieldsContent>
                  </Form.Field>
                </section>
              ) : ''}
              <FormSubHeader>
                {translate('createEvent.form.subHeader.dateNTime')}
              </FormSubHeader>
              <section className='section'>
                <Form.Field name='position-timezone'>
                  <FieldsHeader>
                    <FieldsOrderNumber>4</FieldsOrderNumber>
                    <FieldsHeaderText>{translate('eventTimezone')}</FieldsHeaderText>
                  </FieldsHeader>
                  <FieldsContent>
                    <Field
                      name='timezone'
                      component={HHSingleSelect}
                      otherProps={{
                        id: 'form-timezone',
                        simpleValue: true,
                        searchable: true,
                        clearable: false,
                        options: getTimeZoneOptions(),
                        placeholder: translate('timezone')
                      }}
                    />
                  </FieldsContent>
                </Form.Field>
              </section>
              <section className='section'>
                <Form.Field name='position-start'>
                  <FieldsHeader>
                    <FieldsOrderNumber>5</FieldsOrderNumber>
                    <FieldsHeaderText>{translate('eventWhenStart')}</FieldsHeaderText>
                  </FieldsHeader>
                  <FieldsContent>
                    <FieldsHelpText>
                      {translate('eventWhenStartInstruction')}
                    </FieldsHelpText>
                    <Field
                      name='start'
                      component={HHDatePicker}
                      otherProps={{
                        id: 'form-start',
                        locale: activeLanguage.code,
                        placeholderText: translate('select start date')
                      }}
                    />
                  </FieldsContent>
                </Form.Field>
              </section>
              <section className='section'>
                <Form.Field name='position-end'>
                  <FieldsHeader>
                    <FieldsOrderNumber>6</FieldsOrderNumber>
                    <FieldsHeaderText>{translate('eventWhenEnd')}</FieldsHeaderText>
                  </FieldsHeader>
                  <FieldsContent>
                    <FieldsHelpText>
                      {translate('eventWhenEndInstruction')}
                    </FieldsHelpText>
                    <Field
                      name='end'
                      component={HHDatePicker}
                      otherProps={{
                        id: 'form-end',
                        locale: activeLanguage.code,
                        minDate: moment(values.start),
                        placeholderText: translate('select end date')
                      }}
                    />
                  </FieldsContent>
                </Form.Field>
              </section>
              <div className='nextBtn'>
                <Button onClick={this.saveAndContinue}>{translate('createEvent.nextBtn.basic')}</Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

const CreateEventDescBg = styled.div`
  background-image: url('/img/event/event-create-bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 100%;
`;

const CreateEventDescContainer = styled.div`
  padding: 15%;
`;

const FieldsContent = styled.div`
  display: grid;
  padding-left: 37px;
`;

const FieldsHeader = styled.div`
  padding-bottom: 8px;
`;

const FieldsHelpText = styled.p`
  color: #A4A4A4;
  font-family: 'Inter';
  font-weight: 500;
  font-size: 14px;
  line-height: 16.94px;
  padding-bottom: 8px;
`;

const FieldsHeaderText = styled.p`
  display: inline-block;
  font-family: 'Quicksand';
  font-size: 20px;
  line-height: 25px;
  font-weight: 500;
  color: #222C5E;
`;

const FieldsOrderNumber = styled.div`
  display: inline-block;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  padding: 3.7px;

  background: #0F70BC;
  border: 2px solid #0F70BC;
  color: #FFFFFF;
  text-align: center;
  margin-right: 1rem;
`;

const FormHeader = styled.div`
  font-family: 'Inter';
  font-weight: 900;
  font-size: 24px;
  line-height: 29.05px;
  font-style: normal;
  color: #333333;
  padding-bottom: 30px;
`;

const FormSubHeader = styled.div`
  font-family: 'Inter';
  font-weight: 500;
  font-size: 24px;
  line-height: 29.05px;
  font-style: normal;
  color: #333333;
  padding-bottom: 24px;
  padding-top: 15px;
`;

const DescTitle = styled.p`
  font-weight: 900;
  line-height: 43.57px;
  font-size: 36px;
  color: #FFFFFF;
  display: flex;
  font-family: 'Inter';
`;

const DescSubTitle = styled.p`
  background: linear-gradient(to right, #48B6CA, #0094FB);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 700;
  font-size: 20px;
  line-height: 26px;
  padding-top: 30px;
  font-family: 'Quicksand';
  width: 60%;
`;

const DescItemList = styled.div`
  padding-top: 60px;
`;

const DescItem = styled.div`
`;

const DescItemText = styled.p`
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #FFFFFF;
  font-family: 'Quicksand';
`;

const DescItemIcon = styled.img.attrs(props => ({
  src: props.url
}))`
  width: 98.06px;
  height: 98.06px;
`;

export default withLocalize(EventFormBasicInfo);



// WEBPACK FOOTER //
// ./src/components/forms/eventFormBasicInfo.js